import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { i18n } from "~/localization/i18n";
import { setCookie } from "~/helpers/cookies";
import { RedirectPage } from "../RedirectPage/RedirectPage";
import { GREETING_SHOWN_KEY } from "~/components/Home/Greeting/Greeting";

import {
  BROADCAST_MESSAGE,
  broadcastChannelManager,
} from "~/broadcastChannel/broadcastChannelManager";

export const SigninCallback = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (user) {
      i18n.changeLanguage(user.profile.lang);
      sessionStorage.removeItem(GREETING_SHOWN_KEY);

      if (user.profile.must_change_pin) {
        setCookie(import.meta.env.VITE_CHANGE_PIN_COOKIE_NAME, true);
        broadcastChannelManager.sendMessage(BROADCAST_MESSAGE.CHANGE_PIN);
        navigate("/change-pin");
        return;
      }
    }

    navigate("/");
  }, [isLoading, user, navigate]);

  return <RedirectPage />;
};
